<template>
	<div class="allchain">
		<leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="全部产业图谱"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
				<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle map_title_tab">
						<span class="title current">{{userdata.zsdn_version==2 ? '全国重点产业链' : '从产业图谱找企业'}}</span>
						<span class="title" @click="freeRouter('/industrial-opportunities?id=1')">{{userdata.currentCity.text}}推荐产业链</span>
						<span class="title" @click="freeRouter('/industrial-opportunities?id=2')">关注的产业链</span>
						
						<div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>  
						<div class="opport-screen-list1">
							<dl class="opport-screen bdbe">
								<dt class="fl">大分类</dt>
								<dd class="fl">
									<span :class="searchtype == list.value?'a-screen current':'a-screen'"
										@click="searchtype = list.value;onClickBigClas(list)" :key="i"
										v-for="(list,i) in biglist">{{list.name == '信息技术' ?'数字经济':list.name}}({{ list.num }})
									</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">小分类</dt>
								<dd class="fl">
									<span :class="searchtype1 == 0?'a-screen current':'a-screen'"
										@click="searchtype1=0;getchainlist(0)">全部</span>
									<span :class="searchtype1 == list.value?'a-screen current':'a-screen'"
										@click="smClick(list.value)" :key="i"
										v-for="(list,i) in smalllist">{{list.name}}({{ list.num }})</span>
									<span class="fr pt display-inlineblock"><vedioTips :type="2"></vedioTips></span>
									<span class="dib py-1 ml-5 orgfont">260多条动态产业链图谱，覆盖所有重点产业。查看产业链方便，还能一键查看企业详情，特别方便！</span>
									<span class="fr pt display-inlineblock orgfont" v-if="userdata.zsdn_version==1">产业链招商，最基础的工作就是搞清楚：产业链上下游各个环节，都有哪些重点企业;<br>选择某条您关注的产业链打开，各个节点有对应的重点企业，还可以点击查看企业详情。</span>
								</dd>
							</dl>
						</div>
					</div>
				<ul class="hotchain-list oh whitebox" style="padding: 30px 0;margin-top: 10px;">
					<li v-for="(list,index) in chainlist" :key="index" @click="chainrouter1(list.chainId)" class="fl">
						<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
							<h5 class="title">{{list.chainName}}</h5> 
					</li>
				</ul>
			</div>
			
		</div>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'allchain',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "全国图谱-更多产业图谱",
				curWebsite:this.$api.getWebsiteType(),
				userdata: {},
				searchtype: 0,
				searchtype1: 0,
				navtype: 0,
				searchtext: '',
				yj_itemcode:"",
				isShowFreeUserTips: false,
				biglist: [{
						name: "数字经济",
						value: 10561, 
						itemcode:"L-SZJJ",
					},
					{
						name: "高端制造",
						value: 10562,
						itemcode:"L-GDZZ",
					},
					{
						name: "能源环保材料",
						value: 10563,
						itemcode:"L-NYHBCL",
					},
					{
						name: "大健康",
						value: 10560,
						itemcode:"L-DJK",
					},
					{
						name: "现代服务业",
						value: 10637,
						itemcode:"L-XDFWY",
					},
					{
						name: "大消费",
						value: 10644,
						itemcode:"L-DXF",
					},
					{
						name: "未来产业",
						value: 13450,
						itemcode:"L-DXF",
					},
				],
				smalllist: [],
				chainlist: [],
				yj_mkcode: 'B',
			}
		},
		watch: {
				$route: function (newVal,oldVal) {  
						if(this.$route.query.bc){
							let quertyType=this.$route.query.bc;
							let quertyType1 = this.$route.query.sc;
							this.searchtype1 = quertyType1?quertyType1:'';
							this.searchtype=quertyType?quertyType:10561;
							console.log(this.searchtype,this.searchtype1);
							this.getparameterList(this.searchtype);
							this.getchainlist();
						} 
				}
		}, 
		created() {
			this.yj_mkcode = this.userdata.token && this.curWebsite.type == 6  ? 'L':'B';
			
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			this.userdata = this.getuseriformation();
			if(this.userdata.groupType != 1 || !this.userdata.token){ //1正式 2免费 0试用
				this.isshowWaterMark = true;
			}
			this.getparameterList(this.searchtype);
			

			// this.searchtype=this.biglist[0].value;
			let quertyType=this.$route.query.bc;
			let quertyType1 = this.$route.query.sc;
			this.searchtype1 = quertyType1?quertyType1:'';
			this.searchtype=quertyType?quertyType:10561;
			let serckeyword = this.$route.query.kw;
			if (serckeyword) {
				this.searchtext = serckeyword;
				this.searchkwfun();
			}else{
				this.getchainlist();

			}
		},
		mounted() {},
		methods: {
			onClickBigClas(list){
				console.log(list,1232132130808098);
				this.getparameterList(list.value);
				this.searchtype1=0;
				this.getchainlist(list.value);
			},
			smClick(value) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.searchtype1=value;
				this.getchainlist(value)
			},
			freeRouter(url){
				if(this.userdata.token){
					this.routerself(url);
				}else {
					this.isShowFreeUserTips = true;

				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			//搜索关键词
			searchkwfun() {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext='';
					return;
				}
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext == "") {
					this.$message({
						type: 'warning',
						message: "搜索信息不能为空"
					})
					return;
				}
				this.getchainlist('search'); 
			},
			chainrouter1(chainid) {
				let routeUrl = this.$router.resolve({
					path: '/chain',
					query: {
						id: chainid
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			getparameterList(value) {
				var _this = this;
				var ajaxurl = this.$api.cyl.parameter.chain() + '?parentValue=' + value;
				if(this.curWebsite.type == '7' || this.curWebsite.type == '1' || this.curWebsite.type == '8' || this.curWebsite.type == '9' || this.curWebsite.type == '3') {
					this.yj_itemcode = 'B-QGTP';
				} else {
					this.biglist.forEach(list=>{
					 if(list.value == value){
						this.yj_itemcode=list.itemcode;
						}
				});
				}
				
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					if (res.data.success) {
						console.log('产业链参数',res)
						if (value != '') {
							_this.smalllist = res.data.list;
						} else {
							let temData = res.data.list;
							temData.forEach((list)=>{
								_this.biglist.forEach((item)=>{
									if(item.value == list.value){
										item.num = list.num;
									}
								})
							})
							// _this.biglist=res.data.list; //本地写死顺序
							// _this.searchtype = _this.biglist[0].value;
							_this.getparameterList(_this.searchtype);
						}
						// _this.getchainlist();
					} else {

					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			getchainlist(type) {
				var _this = this;
				this.bus.$emit('loading', true);
				if (type == "search") {
					var ajaxurl = this.$api.cyl.chain.list() + '?kw=' + _this.searchtext;
				} else {
					this.searchtext = "";
					var ajaxurl = this.$api.cyl.chain.list() + '?bigClass=' + _this.searchtype + '&smallClass=' + _this
						.searchtype1;
				}
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					if (res.data.success) {
						console.log('产业链',res,ajaxurl);
						_this.chainlist = res.data.list;
						_this.bus.$emit('loading', false);
					} else {

					}
				}).catch(function(error) {
					_this.bus.$emit('loading', false);
					// 请求失败处理 console.log(error);
				});
			}

		},
	}
</script>

<style>

</style>